(function () {
    'use strict';

    angular.module('ib-apis-form-module').constant('ApisFormConstants', {
        DOCUMENT_TYPES: {
            'DNI': 'DNI',
            'GREENCARD': 'GREENCARD',
            'REDRESSNUMBER': 'REDRESSNUMBER',
            'KNOWNTRAVELERNUMBER': 'KNOWNTRAVELERNUMBER',
            'OTHERS': 'OTHERS',
            'PSPT': 'PSPT',
            'TITLE': 'TITLE',
            'VISA': 'VISA',
            'CREWCERT': 'CREWCERT',
            'RESCARD': 'RESCARD',
            'MILITARYCARD': 'MILITARYCARD'
        },
        TYPE_DATA_FORM: {
            'ADDITIONAL_INFO': 'additionalData',
            'EMERGENCY_INFO': 'emergencyData',
            'UPDATE_SHOW_FOR_ALL': 'showForAll',
            'UPDATE_SHOW_DATA': 'showData'
        },
        DOCUMENT_FIELDS: {
            'NUM_DOC': 'NUM_DOC',
            'EXPIRY_DOC': 'EXPIRY_DOC',
            'ISSUE_DOC': 'ISSUE_DOC',
            'CNTRY_DOC': 'CNTRY_DOC',
            'CITY_DOC': 'CITY_DOC'
        },
        FIELDS: {
            'TITLE': 'TITLE',
            'NAME': 'NAME',
            'SURNAME': 'SURNAME',
            'GENDER': 'GENDER',
            'BIRTH_DATE': 'BIRTH_DATE',
            'DESTINATION_ADDRESS': 'DESTINATION_ADDRESS',
            'DESTINATION_CITY': 'DESTINATION_CITY',
            'DESTINATION_STATE': 'DESTINATION_STATE',
            'DESTINATION_ZIP': 'DESTINATION_ZIP',
            'DESTINATION_COUNTRY': 'DESTINATION_COUNTRY',
            'HOME_ADDRESS': 'HOME_ADDRESS',
            'HOME_CITY': 'HOME_CITY',
            'HOME_STATE': 'HOME_STATE',
            'HOME_ZIP': 'HOME_ZIP',
            'HOME_COUNTRY': 'HOME_COUNTRY',
            'EMERGENCY_CONTACT_NAME': 'EMERGENCY_CONTACT_NAME',
            'EMERGENCY_CONTACT_PHONE': 'EMERGENCY_CONTACT_PHONE',
            'NATIONALITY': 'NATIONALITY',
            'CITY_OF_BIRTH': 'CITY_OF_BIRTH'
        },
        GENDERS: {
            'MALE': 'MALE',
            'FEMALE': 'FEMALE',
            'DEFAULT_GENDER': 'MALE'
        },
        TITLES: {
            'MR': 'MR',
            'MRS': 'MRS',
            'MSS': 'MSS'
        },
        SPANISH_NATIONALITY: 'ES',
        USA_NATIONALITY: 'US',
        TAB_STATES: {
            'NOT_TOUCHED': 'NOT_TOUCHED',
            'COMPLETED': 'COMPLETED',
            'WARNING': 'WARNING'
        },
        TAB_SCROLL_ID: '#APIS_TAB_',
        ADDTIONAL_ERROR_SERVICE: {
            'PASSENGER_IS_UNCHECKABLE': 'PASSENGER_IS_UNCHECKABLE'
        },
        PASSENGER_STATUS: {
            'ALLOWED': 'ALLOWED',
            'NOT_ALLOWED': 'NOT_ALLOWED'
        }
    });

})();